// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1zAsV","header":"MessagesList_header__fFcbC","chat":"MessagesList_chat__1LjCG"};